import { CustomIconComponentProps } from "@ant-design/icons/es/components/Icon";
import Icon from "@ant-design/icons";

export function ResidualWasteIcon(props: Partial<CustomIconComponentProps>) {
  return (
    <Icon
      {...props}
      component={() => (
        <svg
          width={props.width || 24}
          height={props.height || 24}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity="0.1"
            d="M14.9286 4.35059H10.5387L3.57275 15.7583L5.91146 19.323H19.0515L21.0009 15.7583L14.9286 4.35059Z"
            fill="#094308"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.3568 11L21.3227 14.321C21.876 15.2558 21.8808 16.4166 21.3353 17.3559L20.4486 18.8825C19.9117 19.8069 18.9234 20.3758 17.8544 20.3758H14.9443V18.3758H17.8544C18.2108 18.3758 18.5402 18.1862 18.7191 17.878L19.6058 16.3514C19.7876 16.0383 19.786 15.6514 19.6016 15.3398L17.6358 12.0188L19.3568 11Z"
            fill="#094308"
          />
          <path
            d="M12.3115 19.2725L14.9653 16.6992V22.0576L12.3115 19.2725Z"
            fill="#094308"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.4618 20.3369L6.6026 20.3115C5.5164 20.3044 4.5189 19.7106 3.99474 18.7592L3.14285 17.213C2.62699 16.2767 2.64837 15.1366 3.19896 14.2202L4.69776 11.7258L6.4121 12.7559L4.91329 15.2503C4.72976 15.5558 4.72264 15.9358 4.89459 16.2479L5.74648 17.7941C5.9212 18.1113 6.2537 18.3092 6.61577 18.3116L10.4749 18.337L10.4618 20.3369Z"
            fill="#094308"
          />
          <path
            d="M6.99938 10.037L7.83827 13.6371L3.24522 10.8773L6.99938 10.037Z"
            fill="#094308"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.04486 7.85168L8.99645 4.52224C9.54575 3.58514 10.5587 3.01816 11.6447 3.03992L13.4097 3.07528C14.4785 3.0967 15.4552 3.68526 15.9735 4.62025L17.3843 7.16547L15.6351 8.13509L14.2243 5.58987C14.0515 5.27821 13.7259 5.08202 13.3697 5.07488L11.6046 5.03952C11.2426 5.03226 10.905 5.22126 10.7219 5.53362L8.77029 8.86306L7.04486 7.85168Z"
            fill="#094308"
          />
          <path
            d="M17.6959 10.0034L14.1587 8.9299L18.8453 6.3321L17.6959 10.0034Z"
            fill="#094308"
          />
        </svg>
      )}
    />
  );
}
